//
// Hoffmann Rathbone - Site JS
//

//
// Check if JS is on in browser, if so remove the `no-js` class from body
//
document.body.classList.remove('no-js');

//
// Remove preload class onload
//
window.onload = function () {
	document.body.classList.remove('preload');
};

//
// Cookie consent functions
//
const expiryDate = new Date;
expiryDate.setFullYear(expiryDate.getFullYear() +1);

function cookiesAccept() {
    console.info('Accepted cookies');
    document.cookie = 'CookieConsent=true; expires=' + expiryDate.toUTCString() + ';';
}
function cookiesDecline() {
    console.info('Declined cookies');
    document.cookie = 'CookieConsent=false; expires=' + expiryDate.toUTCString() + ';';
}
function cookiesReset() {
    document.cookie = 'CookieConsent=';
}

//
// Cookie consent event listeners
//
window.addEventListener("DOMContentLoaded", (event) => {
    cookieConsentBannerDecline = document.querySelector('#js-cookie-consent-decline');
    cookieConsentBannerAccept = document.querySelector('#js-cookie-consent-accept');
    
    if (cookieConsentBannerDecline) {
        cookieConsentBannerDecline.addEventListener("click", cookiesDecline);
    }
    if (cookieConsentBannerAccept) {
        cookieConsentBannerAccept.addEventListener("click", cookiesAccept);
    }
});

//
// Sign up popup functions
//

// Define popup elements
const showDelay = 30000; // 30 seconds
const popupBackdrop = document.querySelector('#js-popup-backdrop');
const popupDismiss = document.querySelector('#js-popup-dismiss');
const openNext = new Date;
openNext.setDate(openNext.getDate() + 1); // Next calendar day

// Check for presence of `popupBackdrop`, if so show popup after delay
if (popupBackdrop) {
    // If so, toggle the class after value of `showDelay`
    window.addEventListener('load', function() {
        setTimeout(function() {
            popupBackdrop.classList.toggle('popup--visible');
        }, showDelay);
    })
}

// Listen for click events
document.addEventListener('click', function (event) {

	// Check if clicked element is either the dismiss link or backdrop
	if (event.target !== popupBackdrop && event.target !== popupDismiss) return;

	// If so, toggle classes to hide and add a cookie to prevent popup returning later
	popupBackdrop.classList.toggle('popup--visible');
    console.info('Sign up popup dismissed');
    document.cookie = 'PopupDismissed=true; expires=' + openNext.toUTCString() + ';';

}, false);

//
// Site navigation (.site-header)
//

// Define menu elements
const menuToggle = document.querySelector('#js-main-nav-toggle');
const menuContainer = document.querySelector('#js-main-nav-container');
const menuBackdrop = document.querySelector('#js-main-nav-backdrop');

// Listen for click events
document.addEventListener('click', function (event) {

	// Check if clicked element is either the toggle or backdrop
	if (event.target !== menuToggle && event.target !== menuBackdrop) return;

	// If so, change ARIA and toggle classes used to reveal
	const open = JSON.parse(menuToggle.getAttribute('aria-expanded'));
	menuToggle.setAttribute('aria-expanded', !open);
	menuToggle.classList.toggle('main-nav__toggle--active');
	menuContainer.classList.toggle('main-nav__container--active');
	menuBackdrop.classList.toggle('main-nav__backdrop--active');
	document.body.classList.toggle('no-scroll');

}, false);

//
// Init and setup for headroom.js
//

// Grab header element
var myElement = document.querySelector('#js-site-header');

// Customise
var options = {
	offset: 200,
};

// Construct an instance of Headroom, passing the element
var headroom  = new Headroom(myElement, options);

// Initialise
headroom.init();

//
// Add labels to form fields on the payment page
//

const cardExpiryInput = document.querySelector('#gateway-2-form .card-expiry');

if(cardExpiryInput) {
    cardExpiryInput.insertAdjacentHTML('afterend', '<span class="card-expiry__message">Please note: Card expiry date needs to be in a MM / YYYY format</span>');
}
